import Vue from "vue";
import Vuex from "vuex";
import platform from "./modules/platform";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    platform
  }
});
